import React, { useEffect, useRef } from 'react';
import Link from '../../../Link';
import { Badge } from '../../..';
import Avatar from '../../../Avatar';
import { ChevronRight } from '../Icons';
import * as Styles from './styles';
import getLinks from '../../utils/links';
import { sendClickEvent } from '../../utils';
import { useScrollLock, useOverflowNavigation, useClickOutsideOverflow } from '../../services';
import { Banner } from '../Banner';
export const OldOverflowMenu = ({ headerWrapperRef, openSubMenu, setOpenSubMenu, accountInfo, activeTestABFeaturedMenu, fixed, hasActiveTestAB, }) => {
    var _a, _b, _c;
    const firstMenuItem = useRef(null);
    const wrapperRef = useRef(null);
    const { isLogged, profilePicture, userName, publicAccountId } = accountInfo;
    const links = getLinks(publicAccountId, hasActiveTestAB);
    const { lockScroll, unlockScroll } = useScrollLock();
    const menuButton = (_a = headerWrapperRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('.burger-menu');
    const profileButton = (_b = headerWrapperRef.current) === null || _b === void 0 ? void 0 : _b.querySelector('[data-ds-component="DS-Profile-Button"]');
    useOverflowNavigation({
        openSubMenu,
        setOpenSubMenu,
        menuButton,
        profileButton,
        wrapperRef,
    });
    useClickOutsideOverflow({
        openSubMenu,
        setOpenSubMenu,
        menuButton,
        profileButton,
        wrapperRef,
    });
    useEffect(() => {
        const isMobile = window.document.body.clientWidth < 840;
        if (openSubMenu && isMobile) {
            lockScroll();
        }
        else {
            unlockScroll();
        }
    }, [lockScroll, openSubMenu, unlockScroll]);
    const headerBoundings = (_c = document.querySelector('#header')) === null || _c === void 0 ? void 0 : _c.getBoundingClientRect();
    const cssVar = {
        '--header-position': `${(headerBoundings === null || headerBoundings === void 0 ? void 0 : headerBoundings.top) || (headerBoundings === null || headerBoundings === void 0 ? void 0 : headerBoundings.height)}px`,
    };
    const overflowWrapperClasses = [!isLogged && 'hide-non-logged', hasActiveTestAB && 'has-navbar', fixed && 'fixed']
        .filter(Boolean)
        .join(' ');
    return (React.createElement(React.Fragment, null,
        React.createElement(Styles.MobileOverlay, { className: openSubMenu ? 'show' : '', onClick: () => setOpenSubMenu(false), "data-testid": "mobile-overlay-overflow-menu" }),
        React.createElement(Styles.OverflowWrapper, { id: "ds-overflow-menu", "aria-hidden": !openSubMenu, "aria-expanded": openSubMenu, className: overflowWrapperClasses, ref: wrapperRef, "data-testid": "overflow-menu", style: cssVar }, links.map((link, index) => {
            if (!activeTestABFeaturedMenu && link.title === 'Banner') {
                return null;
            }
            return (React.createElement(Styles.FlyOutItem, { key: `fly-out-item-${index}`, className: `${link.divider ? 'divider' : ''} ${activeTestABFeaturedMenu ? 'has-pos' : ''}` },
                React.createElement(Link, { href: link.href, tabIndex: openSubMenu ? 0 : -1, className: "flyout-link", ref: index === 0 ? firstMenuItem : null, onClick: () => sendClickEvent(link.objectDetail, hasActiveTestAB ? 'navbar' : 'sub_menu') },
                    link.title === 'Meu cadastro' && (React.createElement(React.Fragment, null,
                        React.createElement(Styles.DesktopLinkWrapper, null,
                            React.createElement(Avatar, { size: "32px", src: profilePicture }),
                            React.createElement(Styles.InfoWrapper, null,
                                React.createElement(Styles.Name, null, userName.split(' ')[0]),
                                React.createElement(Styles.Myaccount, null, "Minha Conta")),
                            React.createElement(Styles.ChevronRightWrapper, null,
                                React.createElement(ChevronRight, null))),
                        React.createElement(Styles.TabletLinkWrapper, null,
                            React.createElement(Styles.IconWrapper, null,
                                React.createElement(link.Icon, { size: "16" })),
                            link.title))),
                    activeTestABFeaturedMenu && link.title === 'Banner' && React.createElement(Banner, null),
                    link.title !== 'Meu cadastro' && link.title !== 'Banner' && (React.createElement(React.Fragment, null,
                        React.createElement(Styles.IconWrapper, null,
                            React.createElement(link.Icon, { size: "16" })),
                        link.title,
                        hasActiveTestAB && React.createElement(ChevronRight, { className: "arrow-right" }),
                        link.badge && !activeTestABFeaturedMenu && (React.createElement(Styles.FlyOutLinkBadge, null,
                            React.createElement(Badge, { "aria-label": "Novo" }, "Novo"))))))));
        }))));
};
OldOverflowMenu.displayName = 'OldOverflowMenu';
